import { useContext } from 'react';
import { UploadContext } from '../../components/MediaUploadProvider';

export default function useUploadContext() {
  const context = useContext(UploadContext);
  if (!context) {
    throw new Error('useMediaContext must be used within a useMediaContext');
  }
  return context;
}
